module.exports = __webpack_public_path__ + "static/media/IMG_0560.6ee72e60.jpeg";